import { Component, OnInit } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  template: `
    <div
      [ngStyle]="{'visibility' : showLoader ? 'visible' : 'hidden'}"
      class="overlay position-fixed p-3 h-100 w-100 d-flex justify-content-center align-items-center"
      style="z-index:1060;">
      <div class="four-dots"></div>
    </div>
  `,
})
export class LoaderComponent implements OnInit {
  showLoader: boolean = false;
  constructor(public _loader: LoaderService) {}

  ngOnInit() {
    this._loader.loader$.subscribe((loader: boolean) => {
      this.showLoader = loader;
    });
  }
}
